import { combineReducers } from 'redux';

import { AuthState, authReducer } from '../actions/auth';
import { UsersState, usersReducer } from '../actions/users';
import { DocumentsState, documentsReducer } from '../actions/documents';
import { SectionsState, sectionsReducer } from '../actions/sections';

export interface MainReducerState {
    readonly auth: AuthState;
    readonly users: UsersState;
    readonly documents: DocumentsState;
    readonly sections: SectionsState;
}

const mainReducer = combineReducers<MainReducerState>({
    auth: authReducer,
    users: usersReducer,
    documents: documentsReducer,
    sections: sectionsReducer,
});

export default mainReducer;

export interface RequestState<T = any> {
    readonly data?: T;
    readonly items?: T;
    readonly error?: any;
    readonly loading: boolean;
    readonly response?: any;
    readonly success?: boolean;
    readonly total?: number;
}
